import { Injectable } from '@angular/core';
import { UiToolsProvider } from '../ui-tools/ui-tools';
import { Capacitor } from '@capacitor/core';
import * as _ from 'lodash';
import * as moment from 'moment';

declare let CmKit: any;

/*
  Generated class for the NativeAccessProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class NativeAccessProvider {
  configs = {
    geolocation: {
      title: 'Turn on location services?',
      description: `<div>Location services are required for several CDLLife app features.</div>

      <div class="cm-Margin--small-top">We'll use your location to show posts in the <b>Nearby Feed</b>, to show friends in <b>Discover</b>, and to power the <b>Places & Navigation</b> features within the Services tab.</div>
       <div class="cm-Margin--small-top">We will only use your location in the background when you are actively using the  <b>Trip Planner</b> for GPS navigation. </div>`,
      button: 'Continue',
      cancel: '',
      delay: 0, // will ask again in zero days (no delay)
    },
    notifications: {
      title: 'Turn on notifications?',
      description: `We can let you know when users message you, notify you about new features, and other important account activities.`,
      button: `Turn push notifications on`,
      cancel: 'Dismiss',
      delay: 7, // will ask again in 7 days
    },
  };

  promises: any = {};

  constructor(public uiTools: UiToolsProvider) {}

  async hasAttempted(key) {
    return (await this.getState(key)) !== 'prompt';
  }

  async getState(key) {
    if (Capacitor.isPluginAvailable('Permissions')) {
      // const data = await Permissions.query({ name: key });
      // let state = data && data.state;

      // if (
      //   Capacitor.getPlatform() === 'android' &&
      //   key === 'geolocation' &&
      //   state === 'denied'
      // ) {
      //   // Android is never saying "prompt", so it's all thrown off.
      //   // as such, we'll use some local storage help
      //   if (!localStorage.getItem('NATIVE_ACCESS_GEOLOCATION')) {
      //     return 'prompt';
      //   }
      // }

      // return state;
    } else {
      return 'prompt';
    }
  }

  async request(key, opts?: { title: string; description: string }) {
    if (this.promises[key]) return this.promises[key];

    return (this.promises[key] = new Promise<void>((resolve, reject) => {
      resolve();
    }).then(async () => {
      if (await this.hasAttempted(key)) return true;

      if (this.shouldDelay(key)) {
        return false;
      }

      const configs = _.get(this.configs, key);

      if (!configs) return;

      const res = await this.uiTools.actionSheetPrompt({
        title: (opts && opts.title) || configs.title,
        description: (opts && opts.description) || configs.description,
        button: configs.button,
        cancel: configs.cancel,
      });

      delete this.promises[key];

      if (res) {
        // TODO - ask access?
        // This will be handled by the place asking for it for now

        if (Capacitor.getPlatform() === 'android' && key === 'geolocation') {
          localStorage.setItem('NATIVE_ACCESS_GEOLOCATION', 'true');
        }

        return true;
      }

      return false;
    }));
  }

  shouldDelay(key) {
    const existing = localStorage.getItem('NativeAccessProvider_' + key),
      delayToSet = _.get(this.configs, key + '.delay') || 0;

    localStorage.setItem(
      'NativeAccessProvider_' + key,
      moment().add(delayToSet, 'days').toISOString()
    );

    if (!existing) return false;

    if (new Date() > moment(existing).toDate()) {
      return false;
    } else {
      return true;
    }
  }
}



// WEBPACK FOOTER //
// ./src/providers/native-access/native-access.ts